import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from '@material-ui/core/TextField';
import i18n from 'i18next';
import _debounce from 'lodash.debounce';
import useStyles from './Select.styles';
import { Icon } from '../icons';

const searchDebounceDelay = 300;

const SearchBox = ({ onChange, searchInputValue }) => {
  const classes = useStyles();

  const handleSearchDebounced = _debounce((e) => {
    const { value } = e.target;
    onChange(value);
  }, searchDebounceDelay);

  return (
    <MaterialTextField
      id="search"
      classes={{ root: classes.textField }}
      type="text"
      name="search"
      placeholder={i18n.t('common.search')}
      defaultValue={searchInputValue}
      onChange={handleSearchDebounced}
      variant="outlined"
      autoComplete="off"
      size="small"
      InputProps={{
        endAdornment: <Icon icon="search" />,
      }}
    />
  );
};

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchInputValue: PropTypes.string,
};

SearchBox.defaultProps = {
  searchInputValue: '',
};

export default SearchBox;
